import {
  CREATE_CHAT_ROOM,
  ADD_USER_INTO_ROOM,
  GET_FUND_MANAGERS_ACTION,
  GET_HEDGE_USER_FREE_SLOTS_ACTION,
  GET_ALL_USERS_ACTION,
  CREATE_APPOINTMENT_ACTION,
  INVEST_IN_FUND,
  CREATE_NOTES,
  GET_NOTES,
  SEARCH_PMRESULT,
  SEARCH_RPRESULT,
  SEARCH_REPORTRESULT,
  CREATE_AUDITLOGS,
  GET_ALL_ADMIN_LIST,
  GET_ALLOCATOR_USERS,
  GET_HEDGEFUND_DETAIL,
  GET_FUND_DETAILS,
  GET_FUND_BIO_USER,
} from "./constants";

export function createRoom(payload, callback) {
  return {
    type: CREATE_CHAT_ROOM,
    payload,
    callback,
  };
}

export function addUserIntoRoom(payload, callback) {
  return {
    type: ADD_USER_INTO_ROOM,
    payload,
    callback,
  };
}

export function getHedgeFundDetails(id) {
  return {
    type: GET_HEDGEFUND_DETAIL,
    id,
  };
}

export function getFundManagers(payload) {
  return {
    type: GET_FUND_MANAGERS_ACTION,
    id: payload,
  };
}
export function getHedgeUserFreeSlots(payload) {
  return {
    type: GET_HEDGE_USER_FREE_SLOTS_ACTION,
    payload,
  };
}

export function getAllUsers() {
  return {
    type: GET_ALL_USERS_ACTION,
  };
}

export function createAppointment(payload, onSuccess) {
  return {
    type: CREATE_APPOINTMENT_ACTION,
    payload,
    onSuccess,
  };
}

export function investInFund(payload) {
  return {
    type: INVEST_IN_FUND,
    payload,
  };
}

export function createNotes(payload, onSuccessAlert, onCloseModal) {
  return {
    type: CREATE_NOTES,
    payload,
    onSuccessAlert,
    onCloseModal
  };
}

export function getNotes(id,callback) {
  return {
    type: GET_NOTES,
    id,
    callback
  };
}
export function getPerformanceMetricsSearchResult(payload) {
  return {
    type: SEARCH_PMRESULT,
    payload
  };
}
export function GetRiskReportSearchResult(payload) {
  return {
    type: SEARCH_RPRESULT,
    payload
  };
}
export function RiskReportSearchResultByMonth(payload) {
  return {
    type: SEARCH_REPORTRESULT,
    payload
  };
}

export function CreateAuditLogs(payload) {
  return {
    type: CREATE_AUDITLOGS,
    payload
  };
}

export function GetFCNTenants() {
  return {
    type: GET_ALL_ADMIN_LIST,
  };
}

export function getAllocatorUsers(payload) {
  return {
    type: GET_ALLOCATOR_USERS,
    payload
  };
}

export function getFundDetails(id, setFollowFunds) {
  return {
    type: GET_FUND_DETAILS,
    id,
    setFollowFunds
  };
}

export function getFundBioUsersAction(id) {
  return {
    type: GET_FUND_BIO_USER,
    id
  };
}